export default __webpack_public_path__ + "twitter-hrz-v1.svg";